import React from 'react';
import { Tag } from '@/components/ui/atoms/Tag';

export interface StatusTabCountProps {
  count: number;
  isActive: boolean;
}

/** Stage candidate count, shared by the visible tabs and the "More" menu. */
export const StatusTabCount: React.FC<StatusTabCountProps> = ({ count, isActive }) => (
  <Tag
    size="sm"
    intent={isActive ? 'info' : 'secondary'}
    variant={isActive ? 'solid' : 'subtle'}
    palette="brand"
    className="tabular-nums"
  >
    {count}
  </Tag>
);
